export const FILE_BROWSER_COLUMN_CHOOSER_POPUP_KEY = 'jarvis.fileBrowser.columnChooserPopup.v1';

export type ColumnChooserPopupSize = {
  width: number;
  height: number;
};

const DEFAULT_COLUMN_CHOOSER_POPUP_SIZE: ColumnChooserPopupSize = {
  width: 320,
  height: 340
};

export function readColumnChooserPopupSize(): ColumnChooserPopupSize {
  try {
    const raw = localStorage.getItem(FILE_BROWSER_COLUMN_CHOOSER_POPUP_KEY);
    if (!raw) return DEFAULT_COLUMN_CHOOSER_POPUP_SIZE;
    const parsed = JSON.parse(raw) as Partial<ColumnChooserPopupSize>;
    const width = Number(parsed.width);
    const height = Number(parsed.height);
    if (!Number.isFinite(width) || !Number.isFinite(height)) {
      return DEFAULT_COLUMN_CHOOSER_POPUP_SIZE;
    }
    return {
      width: Math.max(260, Math.min(width, 480)),
      height: Math.max(260, Math.min(height, 560))
    };
  } catch {
    return DEFAULT_COLUMN_CHOOSER_POPUP_SIZE;
  }
}

export function writeColumnChooserPopupSize(size: ColumnChooserPopupSize): void {
  try {
    localStorage.setItem(FILE_BROWSER_COLUMN_CHOOSER_POPUP_KEY, JSON.stringify(size));
  } catch {
    // ignore quota / private mode errors
  }
}
